var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenId = function SvgOpenId(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--huma-color-integration-open-id)",
    d: "M18.674 36.48C9.264 35.622 2 30.636 2 24.56c0-5.856 6.79-10.736 15.783-11.802v3.526C11.893 17.286 7.58 20.625 7.58 24.56c0 4.16 4.755 7.627 11.094 8.42zm9.046-15.782 3.567-2.213c-1.677-1.037-3.78-1.808-6.135-2.206v-3.52c3.89.463 7.384 1.647 10.064 3.316l3.632-2.245v6.868z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7931e",
    d: "M18.674 6.599V36.48l5.58-3.5V3z"
  })));
};
export default SvgOpenId;